import { render, staticRenderFns } from "./testimonials.vue?vue&type=template&id=614f85e4&scoped=true&"
import script from "./testimonials.vue?vue&type=script&lang=ts&"
export * from "./testimonials.vue?vue&type=script&lang=ts&"
import style0 from "./testimonials.vue?vue&type=style&index=0&id=614f85e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614f85e4",
  null
  
)

export default component.exports